import { useMemo, useState } from 'react';
import Button from '../components/Button';
import Icon from '../components/Icon';
import stateData from '../stateData';
import './raceList.css';

const toDuration = (str) => {
    const [hours, minutes, seconds] = str.split(":");
    return (Number(hours) * 60 + Number(minutes)) * 60 + Number(seconds);
}

export const RaceList = ({goToGallery}) => {

    const [sortField, setSortField] = useState('date');
    
    const sorted = useMemo(() => {
        if (sortField === 'date') {
            const list = Object.entries(stateData).sort((a, b) => {
                const bDate = new Date(b[1].date || `${b[1].year}-01-01`);
                const aDate =  new Date(a[1].date || `${a[1].year}-01-01`);
                return bDate - aDate;
            }).map(entry => ({...entry[1], stateName: entry[0]}));
            return list;
        } else if (sortField === 'time') {
            const list = Object.entries(stateData).sort((a, b) => {
                const bTime = toDuration(b[1].time || '6:00:00');
                const aTime = toDuration(a[1].time || '6:00:00');
                return aTime - bTime;
            }).map(entry => ({...entry[1], stateName: entry[0]}));
            return list;
        }
    }, [sortField, stateData])

    return <div className='race-list'>
        <div className="race-list-options">
            <label>Sort by: </label>
            <select onChange={e => setSortField(e.target.value)}>
                <option value="date">Date</option>
                <option value="time">Time</option>
            </select>
        </div>
        {sorted.map(state => {
            return <div 
                key={state.stateName} 
                className={'race-list-item'} 
                onClick={() => !state.isUpcoming}
            >
                <div className="race-list-item-content">
                    {state.upcoming && <div className="list-note">Upcoming</div>}
                    {state.isBQ && <div className="list-note">BQ</div>}
                    <div className="race-list-item-header">
                            <h3 className="race-list-item-header-state">{state.stateName}</h3>
                            <h2>{state.raceName}</h2>
                    </div>
                    <div className="race-list-item-body">
                        {[state.agePlace ? `${state.agePlace} in Age Group` : null,
                        state.genderPlace ? `${state.genderPlace} for Women` : null,
                        state.overallPlace ? `${state.overallPlace} overall` : null].filter(Boolean).join(', ')}
                    </div>
                    {state.time && <div className="race-list-item-body">{state.time}</div>}
                    {state.others && <div className="race-list-item-body">with {state.others}</div>}
                    <div className="race-list-item-body">
                        <span>{state.date || state.year}</span>
                        <Button onClick={() => goToGallery(state.stateName)}>
                            <Icon type='image' /> ({state.photos.length})
                        </Button>
                    </div>
                </div>
                {state.photos.length > 0 && <div className="race-list-item-image" style={{backgroundImage: `url(${state.coverPhoto || state.photos[0].url})`}}></div>}
            </div>
        })}
    </div>
}